import { useEffect, useId, useState } from "react";
import type { LearnerRunHistory, LearnerRunSummary } from "@calega/exercise-engine";
import { getCompletedRunHistory } from "../exercises/learning-api";
import { LearnerHistoryTasks } from "./LearnerHistory";

export function CompletedRunHistory({ runId, onLoaded }: { runId: string; onLoaded?: (run: LearnerRunSummary) => void }) {
  const headingId = useId();
  const [state, setState] = useState<{ runId: string; detail?: LearnerRunHistory; error?: string }>({ runId: "" });
  const [retry, setRetry] = useState(0);
  const current = state.runId === runId ? state : null;

  useEffect(() => {
    const controller = new AbortController();
    setState({ runId });
    void getCompletedRunHistory(runId, controller.signal)
      .then((detail) => {
        if (controller.signal.aborted) return;
        setState({ runId, detail });
        onLoaded?.(detail.run);
      })
      .catch(() => {
        if (!controller.signal.aborted) setState({ runId, error: "Dein Verlauf konnte nicht geladen werden." });
      });
    return () => controller.abort();
  }, [runId, retry, onLoaded]);

  return <section className="completed-run-history learner-history-page analysis-inline-detail history" aria-labelledby={headingId}>
    <h2 id={headingId} className="learner-history-detail-title">Dein Verlauf dieses Durchgangs</h2>
    {current?.error ? <div className="alert error" role="alert">{current.error} <button className="secondary" onClick={() => setRetry((value) => value + 1)}>Erneut laden</button></div>
      : current?.detail ? <LearnerHistoryTasks detail={current.detail} /> : <p role="status">Dein Verlauf wird geladen …</p>}
  </section>;
}
